export function formatNumber(number?: number) {
  if (number) {
    if (number >= 1000000) {
      return `${(number / 1000000).toFixed(0)}M`;
    }
    if (number >= 1000) {
      return `${(number / 1000).toFixed(0)}K`;
    }
  }
  return String(number);
}
